<template>
  <div class="wrapper">
    <AlertSuccessMsg
      ref="alert"
      :title="successMessage"
      class="page-alert-error"
    />
    <SmallAlert ref="smallAlert" :message-text="successMessage" />
    <CustomSearch
      id="cases_search_btn"
      :model-value="keySearch"
      :class-component="'case'"
      placeholder="Search by name"
      @update:modelValue="keySearch = $event"
      @filter="filter"
    />
    <div class="holder-table">
      <TableHeader :class="checkAll || checkSome.length >= 2 ? 'active ' : ''">
        <div
          class="custom-checkbox-group"
          :style="{ width: checkAll || checkSome.length > 1 ? '30.4% !important' : '5%' }"
        >
          <div class="checkbox-wrap">
            <input
              :id="'checkAll_processing'"
              v-model="checkAll"
              class="input-checkbox"
              type="checkbox"
            >
            <label :for="'checkAll_processing'" class="label-checkbox">
              <span>{{ ' ' }}</span>
            </label>
            <span
              class="checkbox-unselect"
              @click="unselectAll"
            >{{ checkAll || checkSome.length >= 2 ? 'Unselect All' : '' }}</span>
          </div>
        </div>

        <div v-show="!checkAll && checkSome.length <= 1" class="email">
          <div class="table-header-box">
            <span class="header-table-text">Custodian Email</span>
          </div>
        </div>

        <div v-show="!checkAll && checkSome.length <= 1" class="screenshots">
          <div class="table-header-box">
            <span class="header-table-text">Screenshots</span>
          </div>
        </div>

        <div v-show="checkAll || checkSome.length > 1" class="screen-filtering-bulk-wrapper">
          <div class="screenshots">
            <div class="toggle-save">
              <div class="toggleWrapper">
                <input
                  :id="'s_screenshots_general'"
                  v-model="enableAllScreenshots"
                  type="checkbox"
                  class="dn"
                >
                <label :for="'s_screenshots_general'" class="toggle">
                  <span class="toggle__handler" />
                </label>
              </div>
            </div>
            <div class="table-header-box">
              <span class="header-table-text">Screenshots</span>
            </div>
          </div>

          <div class="filtering">
            <div class="toggle-save">
              <div class="toggleWrapper">
                <input
                  :id="'s_filtering__general'"
                  v-model="enableAllFiltering"
                  type="checkbox"
                  class="dn"
                >
                <label :for="'s_filtering__general'" class="toggle">
                  <span class="toggle__handler" />
                </label>
              </div>
            </div>
            <div class="table-header-box">
              <span class="header-table-text">Custodian Pre-filtering</span>
            </div>
          </div>
        </div>

        <div v-show="!checkAll && checkSome.length <= 1" class="filtering">
          <div class="table-header-box">
            <span class="header-table-text" style="word-wrap: break-word">Custodian Pre-Filtering in Collect App</span>
          </div>
        </div>

        <div v-show="!checkAll && checkSome.length <= 1" class="date">
          <div
            id="sort_configs_by_date"
            class="table-header-box"
            :class="{
              'sort-active': this.sortBy === 'date',
              'sorted-desc': this.sortOrder === ASC
            }"
            @click="sortedBy('date')"
          >
            <span class="header-table-text">Date range</span>
            <arrowDown class="arrow" />
          </div>
        </div>

        <div v-show="!checkAll && checkSome.length <= 1" class="sources">
          <div class="table-header-box">
            <span class="header-table-text">Data Sources</span>
          </div>
        </div>

        <div
          v-show="checkAll || checkSome.length > 1"
          class="date-sources-balk-wrapper"
          :class="{ disabled: !enableAllFiltering }"
        >
          <div class="date">
            <date-picker
              :id="`date_range_general`"
              v-model="dataRange"
              range
              :format="'DD/MM/YYYY'"
              :range-separator="' - '"
              :editable="false"
              :clearable="false"
              class="datepicker-input"
              :input-class="'datepicker-input'"
              placeholder="Select Date range"
              :disabled-date="disableFutureDates"
            >
              <template #icon-calendar>
                <CalendarIcon25 />
              </template>
              <template #icon-clear>
                <BlueCloseIcon25 />
              </template>
            </date-picker>
          </div>

          <div class="sources">
            <CustomMultiSelect
              :id="`select_apps_general`"
              ref="appsSelect"
              v-model="appsChosen"
              :options="appsOptions"
              :multiple="true"
              placeholder="Choose apps"
              is-savable
              @saved="saveAppsBulk"
              @iconAction="iconSelectAction"
            />
          </div>
        </div>
      </TableHeader>

      <div class="table-body">
        <CustodianSettingsItem
          v-for="(custodian, index) in users"
          :key="index"
          :custodian="custodian"
          @updateConfig="saveClientConfig"
          @deleteConfig="deleteClientConfig"
        />
        <div v-if="users.length <= 0 && !isLoading" class="search-custodians">
          <h3>No custodians found</h3>
        </div>
        <div v-if="isLoading" class="loader-bg">
          <div class="loader-p" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSearch from '@/components/inputs/CustomSearch.vue';
import TableHeader from '@/components/table/TableHeader.vue';
import CustodianSettingsItem from '@/components/cases/case-settings/CustodianSettingsItem.vue';
import AlertSuccessMsg from '@/components/profile/AlertSuccessMsg.vue';
import SmallAlert from '@/components/alerts/SmallAlert.vue';
import checkAll from '@/mixins/checkAll';
import CustomMultiSelect from '@/components/inputs/CustomMultiSelect.vue';
import DatePicker from 'vue2-datepicker';
import debounce from '@/mixins/debounce';
import {APP_LIST_MULTISELECT, ASC, CASE_CONFIG_ENUM, DESC} from '@/constants/const';
import caseCustodianSettings from '@/mixins/caseSettings/caseCustodianSettings';
import ArrowDown from '@/components/icons/ArrowDown.vue';
import CalendarIcon25 from '@/components/icons/CalendarIcon25.vue';
import BlueCloseIcon25 from '@/components/icons/BlueCloseIcon25.vue';

export default {
  name: 'CaseSettingsCustodians',
  components: {
    BlueCloseIcon25,
    CalendarIcon25,
    ArrowDown,
    CustomMultiSelect,
    SmallAlert,
    AlertSuccessMsg,
    CustodianSettingsItem,
    TableHeader,
    CustomSearch,
    DatePicker,
  },
  mixins: [checkAll, debounce, caseCustodianSettings],
  data() {
    return {
      DESC,
      ASC,
      sortBy: 'date',
      sortOrder: DESC,
      isLoading: true,
      dataRange: null,
      dateTo: null,
      dateFrom: null,
      keySearch: '',
      users: [],
      successMessage: '',
      enableAllScreenshots: false,
      enableAllFiltering: false,
      appsChosen: [],
      appsOptions: APP_LIST_MULTISELECT,
    };
  },
  watch: {
    enableAllScreenshots(val) {
      let chosenClientsArray = JSON.parse(JSON.stringify(this.users));
      chosenClientsArray.clientIds = chosenClientsArray
        .filter(client => client.isActive && client.configs.screenshotsConfig.value !== val)
        .map(client => client.client.publicId);

      if (chosenClientsArray.clientIds.length > 0) {
        this.prepareScreenshotsConfig(chosenClientsArray, val);
        this.saveClientConfig(chosenClientsArray);
      }
    },
    enableAllFiltering(val) {
      let chosenClientsArray = JSON.parse(JSON.stringify(this.users));

      chosenClientsArray.clientIds = chosenClientsArray
        .filter(client => client.isActive && client.configs.prefilteringConfig.value !== val)
        .map(client => client.client.publicId);

      if (chosenClientsArray.clientIds.length > 0) {
        this.preparePrefilteringConfig(chosenClientsArray, val);
        if (val) {
          this.saveClientConfig(chosenClientsArray);
        } else {
          this.deleteClientConfig(chosenClientsArray);
        }
      }
    },
    dataRange(value) {
      if (value) {
        this.dateFrom = isNaN(Date.parse(value[0])) == false ? Date.parse(value[0]) : null;
        this.dateTo = isNaN(Date.parse(value[1])) == false ? Date.parse(value[1]) : null;

        let chosenClientsArray = JSON.parse(JSON.stringify(this.users));
        chosenClientsArray.clientIds = chosenClientsArray
          .filter(client => client.isActive)
          .map(client => client.client.publicId);

        this.prepareDateConfig(chosenClientsArray, this.dateFrom, this.dateTo);
        this.saveClientConfig(chosenClientsArray);
      }
    },
  },
  async created() {
    await this.getClientsConfig();
    this.debounce(() => {
      const inactiveScreenshotsConfigArray = this.users
        .filter(client => client.configs.screenshotsConfig.value !== true);
      this.enableAllScreenshots = inactiveScreenshotsConfigArray.length <= 0;

      const disabledFilteringArray = this.users.filter(client => client.configs.prefilteringConfig.value !== true);
      this.enableAllFiltering = disabledFilteringArray.length <= 0;
    }, 1000);
  },
  methods: {
    saveAppsBulk() {
      let chosenClientsArray = JSON.parse(JSON.stringify(this.users));
      chosenClientsArray.clientIds = chosenClientsArray
        .filter(client => client.isActive)
        .map(client => client.client.publicId);

      chosenClientsArray.configs = [
        {
          configName: CASE_CONFIG_ENUM.appList,
          value: this.appsChosen.map(item => item.caseName.toLowerCase()).join(','),
        },
      ];
      this.saveClientConfig(chosenClientsArray);
    },
    disableFutureDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },
    unselectAll() {
      this.users.forEach((item) => {
        item.isActive = false;
      });
    },
    filter() {
      this.isLoading = true;
      this.debounce(() => this.getClientsConfig());
    },
    sortedBy(filterName) {
      this.sortOrder = filterName === this.sortBy && this.sortOrder === DESC ? ASC : DESC;
      this.sortBy = filterName;
      this.getClientsConfig();
    },
    getClientsConfig() {
      this.users = [];
      this.$load(async () => {
        const res = await this.$api.caseConfig.getClientsConfig(
          this.$route.params.slug,
          this.keySearch,
          this.sortBy,
          this.sortOrder,
        );
        this.users = res.data.body.map(custodian => {
          return {
            ...custodian,
            ...this.arrayToNestedObject(custodian.configs),
            isActive: false,
          };
        });
        this.isLoading = false;
      });
    },
    saveClientConfig(custodianArray) {
      this.$load(async () => {
        await this.$api.caseConfig.updateCaseConfig(
          this.$route.params.slug,
          {
            publicIds: custodianArray.clientIds,
            caseConfigurationList: this.nestedObjectToArray(custodianArray.configs),
          });

        this.afterRequest(custodianArray);
      });
    },
    deleteClientConfig(custodianArray) {
      this.$load(async () => {
        await this.$api.caseConfig.deleteCaseConfig(
          this.$route.params.slug,
          {
            publicIds: custodianArray.clientIds,
            caseConfigNameList: custodianArray.configs,
          });

        this.afterRequest(custodianArray);
      });
    },
    afterRequest(custodianArray) {
      if (custodianArray.clientIds.length > 1) {
        this.successMessage = 'Custodians settings were saved';
        this.$refs.smallAlert.showAlert();
        this.isLoading = true;
        this.dataRange = null;
        this.appsChosen = [];
        this.debounce(() => this.getClientsConfig(), 2000);
      } else {
        this.successMessage = 'Custodian ' + custodianArray.email + ' settings saved';
        this.$refs.smallAlert.showAlert();
        this.isLoading = true;
        this.debounce(() => this.getClientsConfig(), 1000);
      }
    },
    arrayToNestedObject(configArray) {
      const configs = {};

      configArray.forEach((item) => {
        switch (item.configName) {
          case CASE_CONFIG_ENUM.screenshots:
            configs.screenshotsConfig = {
              configName: item.configName,
              editable: item.editable,
              value: item.value === 'true',
              isDefault: item.isDefault,
            };
            break;

          case CASE_CONFIG_ENUM.speech:
            configs.speechConfig = {
              configName: item.configName,
              editable: item.editable,
              value: item.value === 'true',
              isDefault: item.isDefault,
            };
            break;

          case CASE_CONFIG_ENUM.prefiltering:
            configs.prefilteringConfig = {
              configName: item.configName,
              editable: item.editable,
              value: item.value === 'true',
              isDefault: item.isDefault,
            };
            break;

          case CASE_CONFIG_ENUM.dateFrom:
            configs.dateFromConfig = {
              configName: item.configName,
              editable: item.editable,
              value: item.value,
              isDefault: item.isDefault,
            };
            break;

          case CASE_CONFIG_ENUM.dateTo:
            configs.dateToConfig = {
              configName: item.configName,
              editable: item.editable,
              value: item.value,
              isDefault: item.isDefault,
            };
            break;

          case CASE_CONFIG_ENUM.appList:
            configs.appConfig = {
              configName: item.configName,
              editable: item.editable,
              value: item.value,
              isDefault: item.isDefault,
            };
            break;

          case CASE_CONFIG_ENUM.gallery:
            configs.galleryConfig = {
              configName: item.configName,
              editable: item.editable,
              value: item.value,
              isDefault: item.isDefault,
            };
            break;

          default:
            break;
        }
      });

      return {configs};
    },
    nestedObjectToArray(clientConfigs) {
      const resultArray = [];

      for (const key in clientConfigs) {
        const config = clientConfigs[key];
        resultArray.push({
          configName: config.configName,
          value: config.value === true
            ? 'true'
            : config.value === false
              ? 'false'
              : config.value
                ? config.value
                : '',
        });
      }
      return resultArray;
    },
    iconSelectAction(optionName) {
      switch (optionName) {
        case 'gallery':
          this.$refs.galleryConfigPopup.openPopups();
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  flex-direction: column;

  .holder-table {
    margin: 15px 0 0;
    position: relative;
    overflow: hidden;
    min-height: 500px;
    height: 80vh;

    .table-header.active {
      min-height: 64px;
      height: 100%;
      justify-content: normal;
      padding-right: 13px;
      background-color: var(--accent-color);
    }

    .custom-checkbox-group {

      .checkbox-wrap {

        .checkbox-unselect {
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          color: #FFFFFF;
          text-transform: initial;
          cursor: pointer;
        }
      }
    }

    .screen-filtering-bulk-wrapper {
      display: flex;
      align-items: center;
      max-width: 240px;
      width: 100%;
      gap: 10px;

      .screenshots,
      .filtering {
        display: flex;
        align-items: center;
        gap: 15px;
        width: 100%;
        word-break: break-word;

        .header-table-text {
          color: var(--white-color);
        }
      }

      .screenshots {
        max-width: 100px;
      }

      .filtering {
        max-width: 130px;
      }
    }

    .disabled {
      pointer-events: none;
      opacity: 0.4;
      transition: all .5s;
    }

    .date-sources-balk-wrapper {
      display: flex;
      align-items: center;
      max-width: 45%;
      width: 100%;

      .date {
        max-width: 49%;
        width: 100%;

        .datepicker-input {
          max-width: 190px;
          width: 18vw;

          & > :first-child > :first-child {
            padding: 8.5px 0 8.5px 13px;
          }
        }
      }

      .sources {
        width: 48%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }

    .toggle-save {
      display: flex;
      width: 30%;
      justify-content: space-between;

      .toggleWrapper {
        input {
          position: absolute;
          left: -99em;
        }
      }

      .toggle {
        cursor: pointer;
        display: inline-block;
        position: relative;
        width: 38px;
        height: 18px;
        border-radius: 90px;
        background-color: var(--white-color);
        border: 1px solid var(--light-gray);
        transition: all 400ms;
      }

      .toggle__handler {
        display: inline-block;
        position: relative;
        z-index: 1;
        top: -.5px;
        left: 2px;
        width: 12px;
        height: 12px;
        border-radius: 50px;
        transition: all 400ms;
        background-color: var(--light-gray);
        transform: rotate(-50deg);
      }

      input:checked {
        + .toggle {

          .toggle__handler {
            background-color: var(--accent-color);
            transform: translate3d(20px, 0, 0) rotate(0);
          }
        }
      }
    }

    .table-body {
      height: 90vh;
      overflow-y: auto;
      scrollbar-color: var(--background-color) transparent;
      scrollbar-width: thin;
      position: relative;
    }

    .table-header {
      max-height: 64px;
      height: 64px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 15px 0 15px 22px;
    }

    .table-header-box {
      cursor: default;

      svg {
        max-width: 16px;
        width: 100%;
      }
    }

    .table-header-box:hover .header-table-text {
      text-decoration: none;
    }

    .email {
      width: 25%;
    }

    .screenshots {
      width: 10%;
    }

    .filtering {
      width: 10%;
      padding: 5px 5px 5px 0;
    }

    .date {
      width: 22%;
    }

    .sources {
      width: 21%;
    }

    .contacts {
      width: 10%;
      padding: 0 5px;
    }

    .calls {
      width: 8%;
    }

    .btn-save-settings {
      width: 400px;
      height: 50px;
      margin: 30px 30px 0 0;
      padding: 14px 20px;
      border-radius: 25px;
    }

    .search-custodians {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 70vh;

      h3 {
        font-size: 16px;
        font-weight: 500;
        line-height: 25px;
        text-align: left;
        color: var(--light-gray);
      }
    }
  }
}

.loader-bg {
  opacity: 0.8;
}
</style>
